<template>
  <input-widget :model="model"
                :attribute="attribute"
                type="select2"
                :disabled="disabled"
                display-field="${item.name}"
                :hint="hint"
                :label="label"
                :options="options"
                :multiple="multiple"
                :items="currentBranch.languages"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18n from "@/shared/i18n";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "LanguageSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {placeholder: i18n.t('Select Language')};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState(['currentBranch']),
    }
  }
</script>

<style scoped>

</style>
